export const LINKS = {
  github: "https://github.com/Prithwish-18",
  linkedin: "http://www.linkedin.com/in/prithwish-s-b66665343",
  email: "prithwishsahoo2021@gmail.com",
  phone: "+91 9163253350",
  location: "Kolkata, West Bengal, India",
  resume: "/resume.pdf",
};

export const NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "certificates", label: "Certificates" },
  { id: "contact", label: "Contact" },
];

export const EXPERIENCE = [
  {
    company: "Zaalima Development",
    role: "Web Development Intern",
    mode: "Remote",
    period: "Mar 2026 — May 2026",
    points: [
      "Building responsive web projects with clean UI/UX and modern frontend tech.",
      "Optimizing performance and navigation flows to lift engagement.",
    ],
    tech: ["React.js", "Tailwind CSS", "JavaScript", "UI/UX"],
  },
  {
    company: "Employability.life × Federation University",
    role: "Intern — XPro Project",
    mode: "Remote",
    period: "Nov 2025 — Jan 2026",
    points: [
      "Collaborated using Azure DevOps for cloud integration workflows.",
      "Gained enterprise-level development and agile workflow expertise.",
    ],
    tech: ["Azure DevOps", "Agile", "Cloud Integration"],
  },
];

export const SKILL_CATEGORIES = [
  {
    name: "Languages",
    level: 85,
    items: [
      { name: "Python", note: "ML challenges, scripting, automation" },
      { name: "C", note: "Systems-level fundamentals" },
      { name: "C++", note: "Competitive programming & DSA" },
      { name: "JavaScript", note: "The engine behind every interface I ship" },
      { name: "HTML5", note: "Semantic, accessible markup" },
      { name: "CSS3", note: "Layout systems, animation, art direction" },
    ],
  },
  {
    name: "Frontend",
    level: 95,
    items: [
      { name: "React.js", note: "Component architecture & hooks-first design" },
      { name: "Next.js", note: "SSR, routing, production React" },
      { name: "Tailwind CSS", note: "Utility-first design systems" },
      { name: "Bootstrap", note: "Rapid responsive prototyping" },
    ],
  },
  {
    name: "3D & Graphics",
    level: 90,
    items: [
      { name: "Three.js", note: "WebGL scenes, particles, shaders" },
      { name: "WebGL", note: "GPU-driven visuals in the browser" },
      { name: "GSAP", note: "Timeline choreography & ScrollTrigger" },
    ],
  },
  {
    name: "Backend",
    level: 75,
    items: [
      { name: "Node.js", note: "Event-driven server runtimes" },
      { name: "Express.js", note: "REST APIs & middleware" },
    ],
  },
  {
    name: "Web",
    level: 88,
    items: [
      { name: "Responsive Design", note: "Mobile-first, fluid layouts" },
      { name: "DOM Manipulation", note: "Performance-aware interactivity" },
      { name: "RESTful APIs", note: "Clean contracts between layers" },
      { name: "UI/UX Principles", note: "Hierarchy, motion, accessibility" },
    ],
  },
  {
    name: "Databases & Tools",
    level: 78,
    items: [
      { name: "Oracle SQL", note: "Relational modeling & queries" },
      { name: "PL/SQL", note: "Stored procedures & triggers" },
      { name: "Git", note: "Version control discipline" },
      { name: "GitHub", note: "Open-source collaboration" },
      { name: "Azure DevOps", note: "Enterprise CI/CD pipelines" },
      { name: "Colab", note: "Notebook-driven ML experiments" },
      { name: "Docker", note: "Containerized environments" },
    ],
  },
  {
    name: "Core CS",
    level: 90,
    items: [
      { name: "Data Structures & Algorithms", note: "Top-3000 Amazon ML Challenge mindset" },
      { name: "Operating Systems", note: "Concurrency, memory, scheduling" },
      { name: "DBMS", note: "Normalization, indexing, transactions" },
    ],
  },
];

export const PROJECT_FILTERS = ["All", "Full-Stack", "AI/RAG", "WebGL/3D", "UI/UX"];

export const PROJECTS = [
  {
    id: "ecommerce-ai",
    title: "E-Commerce Platform with AI Chatbot",
    role: "Lead Developer",
    date: "Jan 2025",
    summary:
      "Scalable product-visualization platform with an integrated AI chatbot for real-time customer support — lifting engagement by 35%.",
    architecture:
      "Vanilla HTML/CSS/JS storefront with a modular product-visualization layer. An AI chatbot widget handles real-time support queries, wired to conversational endpoints with graceful fallbacks.",
    tags: ["Full-Stack", "AI/RAG", "UI/UX"],
    tech: ["HTML5", "CSS3", "JavaScript", "AI Chatbot", "REST APIs"],
    github: "https://github.com/Prithwish-18/E-Commerce-Website-with-AI-Chatbot-Integration",
    live: "https://prithwish-18.github.io/E-Commerce-Website-with-AI-Chatbot-Integration/",
    video: "/videos/ecommerce-ai.mp4",
    gradient: "linear-gradient(135deg, #FF5E36 0%, #1A202C 55%, #00F2FE 100%)",
    metric: "+35% engagement",
  },
  {
    id: "sop-agent",
    title: "Enterprise SOP Agent",
    role: "AI / Full-Stack Developer",
    date: "Apr 2026",
    summary:
      "Context-aware Retrieval-Augmented Generation agent that queries SOP documents with vector embeddings and automated query processing.",
    architecture:
      "RAG pipeline: documents are chunked and embedded into a vector store; incoming queries are embedded, matched by similarity, and passed with retrieved context to the LLM for grounded, accurate answers.",
    tags: ["AI/RAG", "Full-Stack"],
    tech: ["Python", "RAG", "Vector Embeddings", "FastAPI", "React.js"],
    github: "https://github.com/Prithwish-18/Enterprise_SOP_Agent",
    live: "https://ai-opsmind.vercel.app/",
    video: "/videos/sop-agent.mp4",
    gradient: "linear-gradient(135deg, #00F2FE 0%, #0D0D0D 50%, #4A5568 100%)",
    metric: "Vector-grounded answers",
  },
  {
    id: "chrono",
    title: "Chrono",
    role: "Frontend Developer",
    date: "Jun 2026",
    summary:
      "Time-management and productivity web app with responsive UI/UX, interactive timeline components, and dynamic scheduling.",
    architecture:
      "Component-driven frontend with interactive timeline primitives, dynamic scheduling state, and a responsive layout system designed mobile-first.",
    tags: ["Full-Stack", "UI/UX"],
    tech: ["React.js", "JavaScript", "Tailwind CSS", "Framer Motion", "UI/UX"],
    github: "https://github.com/Prithwish-18/Chrono",
    live: "https://chrono-ai-app.preview.emergentagent.com/",
    video: "/videos/chrono.mp4",
    gradient: "linear-gradient(135deg, #4A5568 0%, #0D0D0D 45%, #FF5E36 100%)",
    metric: "Dynamic scheduling",
  },
  {
    id: "extensio-ai",
    title: "Extensio AI",
    role: "Full-Stack Developer",
    date: "2025",
    summary:
      "AI-powered workflow & extension tool boosting user productivity with instant contextual intelligence and smart automation.",
    architecture:
      "Next.js & React-based architecture integrating AI model APIs to process web content in real-time, executing smart browser workflows and content generation.",
    tags: ["AI/RAG", "Full-Stack"],
    tech: ["Next.js", "React.js", "TypeScript", "AI APIs", "Tailwind CSS"],
    github: "https://github.com/Prithwish-18/extensio.ai",
    live: "https://extensio-ai.vercel.app/",
    video: "/videos/extensio-ai.mp4",
    gradient: "linear-gradient(135deg, #00F2FE 0%, #1A202C 60%, #FF5E36 100%)",
    metric: "AI Extension Engine",
  },
  {
    id: "fashion-website",
    title: "Fashion Website",
    role: "Frontend Developer",
    date: "2025",
    summary:
      "High-fashion editorial showcase site featuring sleek product layouts, smooth scrolling transitions, and interactive catalog previews.",
    architecture:
      "Art-directed luxury fashion storefront built with semantic HTML5, modern CSS3 layout engines, and performance-aware JavaScript animations.",
    tags: ["UI/UX", "Full-Stack"],
    tech: ["HTML5", "CSS3", "JavaScript", "Responsive Design", "UI/UX"],
    github: "https://github.com/Prithwish-18/Fashion_website",
    live: "https://prithwish-18.github.io/Fashion_website/",
    video: "/videos/fashion-website.mp4",
    gradient: "linear-gradient(135deg, #FF5E36 0%, #4A5568 50%, #1A202C 100%)",
    metric: "Editorial Layouts",
  },
  {
    id: "window-moving",
    title: "Window Moving",
    role: "Creative Developer",
    date: "2025",
    summary:
      "Interactive desktop-style browser experiment enabling multi-window dragging, spatial layout manipulation, and fluid physics.",
    architecture:
      "Custom JavaScript window management engine utilizing DOM pointer events, dynamic z-index layering, and smooth transform calculations.",
    tags: ["WebGL/3D", "UI/UX"],
    tech: ["JavaScript", "HTML5 Canvas", "CSS3", "DOM API"],
    github: "https://github.com/Prithwish-18/Window_Moving",
    live: "https://prithwish-18.github.io/Window_Moving/",
    video: "/videos/window-moving.mp4",
    gradient: "linear-gradient(135deg, #00F2FE 0%, #4A5568 50%, #0D0D0D 100%)",
    metric: "Interactive DOM Physics",
  },
  {
    id: "amazon-ml-challenge",
    title: "Amazon ML Challenge (2025)",
    role: "ML Engineer / Developer",
    date: "2025",
    summary:
      "High-performance machine learning model repository developed for the Amazon ML Challenge 2025, ranking in the Top 3000 out of 86,000+ global participants.",
    architecture:
      "Feature engineering pipelines, dataset preprocessing scripts, and ensemble machine learning algorithms engineered for large-scale predictive challenge metrics.",
    tags: ["AI/RAG", "Full-Stack"],
    tech: ["Python", "Machine Learning", "Pandas", "NumPy", "Scikit-Learn"],
    github: "https://github.com/Prithwish-18/Amazon_ML_challenge_2025",
    live: "https://github.com/Prithwish-18/Amazon_ML_challenge_2025",
    video: "/videos/amazon-ml-challenge.mp4",
    gradient: "linear-gradient(135deg, #FF5E36 0%, #0D0D0D 50%, #00F2FE 100%)",
    metric: "Top 3000 / 86,000+",
  },
  {
    id: "vogue-shot",
    title: "Vogue Shot",
    role: "Creative Developer",
    date: "2025",
    summary:
      "Dynamic photography portfolio and fashion gallery application with fluid visual reveals, full-screen lightbox, and editorial styling.",
    architecture:
      "Interactive gallery application utilizing CSS Grid, custom lightbox modal interactions, and smooth entrance reveals for photography showcases.",
    tags: ["UI/UX", "WebGL/3D"],
    tech: ["HTML5", "CSS3", "JavaScript", "Animation", "Gallery UI"],
    github: "https://github.com/Prithwish-18/Vogue_Shot",
    live: "https://prithwish-18.github.io/Vogue_Shot/",
    video: "/videos/vogue-shot.mp4",
    gradient: "linear-gradient(135deg, #4A5568 0%, #FF5E36 60%, #0D0D0D 100%)",
    metric: "Modern Gallery UI",
  },
];

export const CERTIFICATES = [
  {
    id: "amazon-ml",
    title: "Amazon ML Challenge 2025",
    descriptor: "Ranked Top 3000 out of 86,000+ international participants.",
    tag: "Top 3.5%",
    icon: "Trophy",
  },
  {
    id: "skepsis",
    title: "Winner — Skepsis Project Dev Rush",
    descriptor: "First place across competing project builds.",
    tag: "Winner",
    icon: "Award",
  },
  {
    id: "nit-durgapur",
    title: "1st Runner-Up — NIT Durgapur CSS Hackathon",
    descriptor: "Podium finish at a national-level styling hackathon.",
    tag: "Runner-Up",
    icon: "Medal",
  },
  {
    id: "hack2skill",
    title: "Round 2 Qualifier — Google Hack2Skill Hackathon",
    descriptor: "Advanced through competitive elimination rounds.",
    tag: "Qualifier",
    icon: "Rocket",
  },
];
